import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { filter, tap } from 'rxjs/operators';
import { AlertConfig, AlertDialog } from '../dialogs/alert/alert.dialog';
import { ConfirmDialog } from '../dialogs/confirm/confirm.dialog';

export interface SimpliscreenDialogConfig<T> extends MatDialogConfig<T> {
	expectResponse?: boolean;
}

@Injectable({ providedIn: 'any' })
export class SimpliscreenDialogService {
	private dialog = inject(MatDialog);

	dialogOpen = false;

	alert(data: AlertConfig, expectResponse = false) {
		this.dialogOpen = true;
		return this.dialog
			.open(AlertDialog, {
				data,
				autoFocus: false,
			})
			.afterClosed()
			.pipe(
				tap(() => this.dialogOpen = false),
				filter((confirmed) => expectResponse ? expectResponse : confirmed)
			);
	}

	confirm(data: AlertConfig, expectResponse = false, config?: MatDialogConfig) {
		this.dialogOpen = true;
		return this.dialog.open(ConfirmDialog, { data, ...config }).afterClosed()
			.pipe(
				tap(() => this.dialogOpen = false),
				filter((confirmed) => expectResponse ? expectResponse : confirmed)
			);
	}

	open(dialog: any, config?: SimpliscreenDialogConfig<any>) {
		this.dialogOpen = true;
		const panelClass = config?.panelClass || 'no-padding-dialog';
		if (Array.isArray(panelClass)) panelClass.push('no-padding-dialog');
		return this.dialog
			.open(dialog, {
				...config,
				panelClass,
				autoFocus: false,
			})
			.afterClosed()
			.pipe(
				tap((res) => this.dialogOpen = false),
				filter((response) => config?.expectResponse ? config.expectResponse : response)
			);
	}

	getDialogById(id: string) {
		return this.dialog.getDialogById(id);
	}

	closeAll() {
		this.dialog.closeAll();
	}
}
